import { wacToken } from '@/libraries/design/foundations';

export const ChromeIcon = ({ isLargeImage }: { isLargeImage: boolean }) => {
	return (
		<svg
			className="width:full"
			fill="none"
			height={isLargeImage ? '80' : '57'}
			viewBox="0 0 58 57"
			width={isLargeImage ? '80' : '58'}
			aria-hidden="true"
		>
			<rect fill={wacToken('color.extended.blue200')} height="57" rx="24" width="57" x=".5" />
			<path
				clipRule="evenodd"
				d="m15.9361 21.9342c-.8574 1.8435-1.3361 3.8987-1.3361 6.0658 0 7.0097 5.0085 12.8495 11.6421 14.1362l3.3918-5.8802c-.2092.0159-.4206.0239-.6339.0239-3.1877 0-5.9547-1.8014-7.3385-4.4418zm-1.5117-4.4982c-2.1541 2.9669-3.4244 6.6171-3.4244 10.564 0 9.2196 6.9315 16.8202 15.8675 17.875.0787.0141.1579.0229.237.0264.6229.0652 1.2553.0986 1.8955.0986 9.9411 0 18-8.0589 18-18 0-2.5199-.5178-4.9189-1.4529-7.0964-.0256-.0703-.0555-.1385-.0893-.2044-2.8004-6.3034-9.1157-10.6992-16.4578-10.6992-5.8821 0-11.1052 2.8214-14.3898 7.1847-.0697.0787-.1317.1629-.1858.2513zm3.7121 1.1114 3.3951 5.873c1.3352-2.7807 4.1776-4.7005 7.4684-4.7005h11.7828c-2.6059-3.7015-6.9119-6.1199-11.7828-6.1199-4.3355 0-8.2235 1.916-10.8635 4.9474zm24.4859 4.7725h-6.7909c.9138 1.3314 1.4485 2.9432 1.4485 4.68 0 1.6267-.469 3.1438-1.2793 4.4234l-5.7225 9.9207c7.3541-.6468 13.1218-6.8218 13.1218-14.344 0-1.6383-.2736-3.2128-.7776-4.6801zm-9.5057 6.908c.3593-.6625.5633-1.4214.5633-2.228 0-2.5847-2.0953-4.68-4.68-4.68s-4.68 2.0953-4.68 4.68c0 .7642.1832 1.4855.5079 2.1226l.1253.2167c.0218.0377.042.0758.0608.1143.8241 1.336 2.3011 2.2264 3.986 2.2264 1.6465 0 3.0944-.8502 3.9286-2.1355l.1175-.2037c.0223-.0388.0459-.0764.0706-.1128z"
				fill={wacToken('color.neutral.light0')}
				fillRule="evenodd"
			/>
			<title id="chrome-icon">Chrome icon</title>
		</svg>
	);
};
